<template>
  <div>
    <p class="border-t-4 border-green bg-green-lightest text-green-dark p-4 rounded-t shadow mb-4" role="alert" v-if="success" v-html="success"></p>
    <p  class="border-t-4 border-red bg-red-lightest text-red-dark p-4 rounded-t shadow mb-4" role="alert" v-else-if="errors" v-html="errors"></p>
    <p class="mb-4" v-else>Update your saved card.</p>
    <div class="flex items-center input-group bg-grey-lighter rounded">
      <span class="flex-1 text-sm p-2 font-medium">{{ card.brand }} ending in <span class="text-base font-normal">{{ card.last4 }}</span></span>
      <input class="w-16 px-2 py-4 bg-transparent text-right" type="text" v-model="expMonth" :disabled="loading" @change="warning">/
      <input class="w-16 px-2 py-4 bg-transparent" type="text" v-model="expYear" :disabled="loading" @change="warning">
      <input class="w-1/6 p-4 bg-transparent" type="text" v-model="zip" :disabled="loading">
      <div class="p-4 rounded-4 bg-grey-light text-grey-darker text-center" v-if="loading">Loading...</div>
      <button class="p-4 rounded-r bg-blue hover:bg-blue-dark text-blue-lightest bg:text-white" @click="updateCard" v-else>Update</button>
    </div>
  </div>
</template>

<script>
if (window.DTK) {
  let stripe = Stripe(window.DTK.stripeKey)
}

export default {
  props: ['card', 'cust'],
  data() {
    return {
      expMonth: this.card.exp_month,
      expYear: this.card.exp_year,
      zip: this.card.address_zip,
      loading: false,
      errors: false,
      success: false
    }
  },
  methods: {
    updateCard() {
      if (!this.expMonth || !this.expYear || !this.zip) {
        this.errors = 'All fields are required.'
        return
      }
      this.loading = true
      axios.patch('/api/v1/settings/source', {
        expMonth: this.expMonth,
        expYear: this.expYear,
        zip: this.zip,
        cardId: this.card.id,
        stripeId: this.cust.id
      })
      .then(({data}) => {
        this.loading = false
        if (data.success) {
          this.success = data.success
          this.errors = false
        } else {
          this.errors = data.error.message
          this.success = false
        }
      })
    },
    warning() {
      this.errors = false
      this.success = false
      let d = new Date()
      let month = d.getMonth() + 1
      if (this.expYear < d.getFullYear()) {
        this.errors = 'Your card has expired. Would you like to try another?'
      }

      if (this.expMonth <= month && this.expYear <= d.getFullYear()) {
        this.errors = 'Your card has expired. Would you like to try another?'
      }

      if (this.expMonth == month + 1 && this.expYear == d.getFullYear()) {
        this.errors = 'Your card will expire soon. Would you like to try another?'
      }
    }
  }
}
</script>
